import type { SerializedThirdParty } from '@enmon/commons/lib/tools';
import type { DefaultOperatorName, Field, RuleGroupType } from 'react-querybuilder';
import {
  containsOwnerTypeUtility,
  createDeviceCategoryField,
  createLorawanRssiField,
  createMeasurementCategoryField,
  createNbiotRssiField,
  createOwnerField,
  createOwnerTypeField,
  createCommodityField,
} from 'routes/reseller-data/common-fields';
import type { ConditionFieldName } from 'routes/reseller-data/const';

export const getFields = (
  currentRules: RuleGroupType,
  thirdParties?: Array<Pick<SerializedThirdParty, 'id' | 'name'>>,
): Field<ConditionFieldName, DefaultOperatorName>[] => {
  const containsUtilityOwnerType = containsOwnerTypeUtility(currentRules);

  return [
    createCommodityField(), // TODO: !WARNING! CHECK POSSIBLY BREAKING CHANGE
    createOwnerTypeField(),
    createOwnerField(containsUtilityOwnerType, thirdParties),
    createLorawanRssiField(),
    createNbiotRssiField(),
    createMeasurementCategoryField(),
    createDeviceCategoryField(),
  ];
};
